import { z } from "zod";

export const getOrderFieldsEnumOptionsSchema = () => {
	return z.object({
		options: z.array(
			z.object({
				value: z.string().nonempty(),
				label: z.string().nonempty(),
				emailLabel: z.string().optional(),
			}),
		),
	});
};

export type OrderFieldsEnumOptionsFormModel = z.infer<
	ReturnType<typeof getOrderFieldsEnumOptionsSchema>
>;
